import React from 'react';
import placeholder from '../../assets/images/placeholder.jpg';

interface Props {
    nft: any
}

const Card: React.FC<Props> = (props) => {
    const getIpfsUri = (uri: string) => {
        return uri.replace('ipfs://', 'https://ipfs.ai-universe.io/ipfs/');
    }

    return (
        <div className='mintcard-wrap'>
            <div className={`alert-img`}>
                {props.nft && props.nft.image
                    ? <img src={getIpfsUri(props.nft.image)} alt='AI Universe' />
                    : <img src={placeholder} alt='Placeholder' />
                }
            </div>
        </div>
    )
}

export default Card